import css from "styled-jsx/css";
import { BACKGROUND_GRAY_COLOR_NAME, WHITE_COLOR_NAME, SPACE_BLUE_COLOR_NAME } from "styles/color-consts";
import Colors from "styles/colors";

const BORDER_RADIUS = "8px";
const BOX_WIDTH = "624px";

export const componentStyles = css.global`
  .welcome-back-homepage-first-fold-component {
    display: flex;
    flex-direction: column;
    align-items: center;

    .last-account-wrapper {
      background: ${Colors[SPACE_BLUE_COLOR_NAME]};
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 16px 0;

      .last-account-details-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: ${BOX_WIDTH};

        .last-account-title {
          width: 100%;
          display: flex;
          justify-content: center;
          background: ${Colors[BACKGROUND_GRAY_COLOR_NAME]};
          border-top-right-radius: ${BORDER_RADIUS};
          border-top-left-radius: ${BORDER_RADIUS};

          font-weight: 400;
          font-size: 32px;
          color: ${Colors.mud};
          padding-top: 12px;
          padding-bottom: 12px;
        }
        .last-account-details {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          border-bottom-right-radius: ${BORDER_RADIUS};
          border-bottom-left-radius: ${BORDER_RADIUS};

          background: ${Colors[WHITE_COLOR_NAME]};

          .user-image-wrapper {
            margin-top: 26px;
            .user-image {
              width: 50px;
            }
          }
          .last-account-user-details {
            margin-top: 16px;
            font-weight: 400;
            font-size: 20px;
            color: ${Colors.mud};
          }

          .last-account-button-wrapper {
            margin-top: 24px;
            margin-bottom: 32px;
          }
        }
      }
    }
    .rest-accounts-wrapper {
      .older-account-boxes-wrapper {
        .account-box {
          border: 2px solid #f0f3ff;
          border-radius: 8px;
          width: ${BOX_WIDTH};
          margin-top: 24px;

          .account-box-data {
            margin: 24px;
            display: flex;
            align-items: center;

            .old-account-image-wrapper {
              margin-left: 6px;
              .old-account-user-image {
                width: 32px;
              }
            }
            .old-account-user-details {
              margin-left: 12px;
              max-width: 330px;

              font-weight: 400;
              font-size: 16px;
              color: ${Colors.mud};
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .old-account-button-wrapper {
              margin-left: auto;
            }
          }
        }
      }
    }
    .general-login-wrapper {
      margin-top: 48px;
      font-weight: 400;
      font-size: 16px;
      .no-account-link {
        padding-left: 6px;
      }
    }
  }
`;
